import { render, staticRenderFns } from "./InEnvRecommCard.vue?vue&type=template&id=3c75549c&"
import script from "./InEnvRecommCard.vue?vue&type=script&lang=js&"
export * from "./InEnvRecommCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports